import { format, parseISO } from 'date-fns';
import type { ViewProductDetailsQuery, ProductAttributeDataFragment } from '~~/graphql';

type DetailProduct = Extract<
    ViewProductDetailsQuery['product'],
    { __typename: 'SimpleProduct' }
>;

type ProductAttributeValue = ProductAttributeDataFragment;
type ProductOutletBundleAttributeValue = NonNullable<DetailProduct['outletBundleAttributes']>[0];

interface AttributeData {
    id: string
    title: string
    value?: string
}

export function useAttributeValue(
    attributeValue: ProductAttributeValue | ProductOutletBundleAttributeValue,
): AttributeData {
    let value: string | undefined;

    switch (attributeValue.__typename) {
        case 'ProductDropdownValue': {
            value = attributeValue.dropdown?.title;
            break;
        }
        case 'ProductMultiselectValue': {
            if (attributeValue.multiselect.length > 0) {
                value = attributeValue.multiselect.map((option) => option.title).join(', ');
            }
            break;
        }
        case 'ProductTagsValue': {
            if (attributeValue.tags.length > 0) {
                value = attributeValue.tags.join(', ');
            }
            break;
        }
        case 'ProductToggleValue': {
            if (attributeValue.toggle !== null) {
                value = attributeValue.toggle ? 'Kyllä' : 'Ei';
            }
            break;
        }
        case 'ProductColorValue': {
            value = attributeValue.color ?? undefined;
            break;
        }
        case 'ProductDateValue': {
            if (attributeValue.date !== null) {
                value = format(parseISO(attributeValue.date), 'd.M.yyyy');
            }
            break;
        }
        case 'ProductNumberValue': {
            value = attributeValue.number?.toLocaleString() ?? undefined;
            break;
        }
        case 'ProductTextValue': {
            value = attributeValue.text ?? undefined;
            break;
        }
        case 'ProductTextareaValue': {
            value = attributeValue.textarea ?? undefined;
            break;
        }
        default:
    }

    return {
        id: attributeValue.attribute.id,
        title: attributeValue.attribute.title || attributeValue.attribute.name,
        value: value
            ? (attributeValue.attribute.prefix || '') + value + (attributeValue.attribute.suffix || '')
            : undefined,
    };
}
